/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateMeetingAgendaItemDto } from '../models/work-create-meeting-agenda-item-dto';
import { WorkMeetingAgendaItem } from '../models/work-meeting-agenda-item';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkUpdateMeetingAgendaItemDto } from '../models/work-update-meeting-agenda-item-dto';

@Injectable({ providedIn: 'root' })
export class WorkMeetingAgendaItemsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `meetingAgendaItemsV2ControllerFindAllPaginated()` */
  static readonly MeetingAgendaItemsV2ControllerFindAllPaginatedPath = '/v2/meeting-agenda-items';

  /**
   * Required permissions: meeting-agenda-items:read, meeting-agenda-items:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingAgendaItemsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingAgendaItemsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 200
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by meetingId query param.
     *           <p>
     *              <b>Format: </b> filter.meetingId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.meetingId=$not:$like:John Doe&filter.meetingId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.meetingId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> sortableRank:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>sortableRank</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'sortableRank:ASC' | 'sortableRank:DESC'>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingAgendaItem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'meetingId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingAgendaItemsV2Service.MeetingAgendaItemsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.meetingId', params['filter.meetingId'], {});
      rb.query('sortBy', params.sortBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkMeetingAgendaItem>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'meetingId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: meeting-agenda-items:read, meeting-agenda-items:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingAgendaItemsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingAgendaItemsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 200
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by meetingId query param.
     *           <p>
     *              <b>Format: </b> filter.meetingId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.meetingId=$not:$like:John Doe&filter.meetingId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.meetingId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> sortableRank:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>sortableRank</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'sortableRank:ASC' | 'sortableRank:DESC'>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingAgendaItem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'meetingId'?: (string | Array<string>);
};
};
}> {
    return this.meetingAgendaItemsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingAgendaItem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'meetingId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingAgendaItem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'meetingId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `meetingAgendaItemsV2ControllerCreate()` */
  static readonly MeetingAgendaItemsV2ControllerCreatePath = '/v2/meeting-agenda-items';

  /**
   * Required permissions: meeting-agenda-items:create, meeting-agenda-items:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingAgendaItemsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingAgendaItemsV2ControllerCreate$Response(
    params: {
      body: WorkCreateMeetingAgendaItemDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeetingAgendaItem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingAgendaItemsV2Service.MeetingAgendaItemsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeetingAgendaItem>;
      })
    );
  }

  /**
   * Required permissions: meeting-agenda-items:create, meeting-agenda-items:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingAgendaItemsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingAgendaItemsV2ControllerCreate(
    params: {
      body: WorkCreateMeetingAgendaItemDto
    },
    context?: HttpContext
  ): Observable<WorkMeetingAgendaItem> {
    return this.meetingAgendaItemsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeetingAgendaItem>): WorkMeetingAgendaItem => r.body)
    );
  }

  /** Path part for operation `meetingAgendaItemsV2ControllerFindOneById()` */
  static readonly MeetingAgendaItemsV2ControllerFindOneByIdPath = '/v2/meeting-agenda-items/{id}';

  /**
   * Required permissions: meeting-agenda-items:read, meeting-agenda-items:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingAgendaItemsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingAgendaItemsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeetingAgendaItem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingAgendaItemsV2Service.MeetingAgendaItemsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeetingAgendaItem>;
      })
    );
  }

  /**
   * Required permissions: meeting-agenda-items:read, meeting-agenda-items:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingAgendaItemsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingAgendaItemsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkMeetingAgendaItem> {
    return this.meetingAgendaItemsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeetingAgendaItem>): WorkMeetingAgendaItem => r.body)
    );
  }

  /** Path part for operation `meetingAgendaItemsV2ControllerDelete()` */
  static readonly MeetingAgendaItemsV2ControllerDeletePath = '/v2/meeting-agenda-items/{id}';

  /**
   * Required permissions: meeting-agenda-items:delete, meeting-agenda-items:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingAgendaItemsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingAgendaItemsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingAgendaItemsV2Service.MeetingAgendaItemsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: meeting-agenda-items:delete, meeting-agenda-items:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingAgendaItemsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingAgendaItemsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.meetingAgendaItemsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `meetingAgendaItemsV2ControllerUpdate()` */
  static readonly MeetingAgendaItemsV2ControllerUpdatePath = '/v2/meeting-agenda-items/{id}';

  /**
   * Required permissions: meeting-agenda-items:update, meeting-agenda-items:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingAgendaItemsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingAgendaItemsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateMeetingAgendaItemDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeetingAgendaItem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingAgendaItemsV2Service.MeetingAgendaItemsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeetingAgendaItem>;
      })
    );
  }

  /**
   * Required permissions: meeting-agenda-items:update, meeting-agenda-items:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingAgendaItemsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingAgendaItemsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateMeetingAgendaItemDto
    },
    context?: HttpContext
  ): Observable<WorkMeetingAgendaItem> {
    return this.meetingAgendaItemsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeetingAgendaItem>): WorkMeetingAgendaItem => r.body)
    );
  }

}
